import { renderCopyHover, renderTextLineClamp } from 'helpers';
import { TFunc, useTranslation } from 'libs/i18n';
import { TableColumn } from 'libs/ui';

import { ClientsListItem } from '../../types';

import { renderStatus } from './renders';

export const getColumns = (t: TFunc): TableColumn<ClientsListItem>[] => [
  {
    field: 'id',
    title: t('client.clients.legal.columns.id'),
    minWidth: 96,
    flex: 1,
    renderCell: (item) => renderCopyHover(item.id),
  },

  {
    field: 'lastSessionDate',
    title: t('client.clients.legal.columns.lastSessionDate'),
    minWidth: 145,
    flex: 1,
    renderCell: (item) => renderCopyHover(item.lastSessionDate),
  },

  {
    field: 'fullName',
    title: t('client.clients.legal.columns.fullName'),
    sortable: true,
    minWidth: 500,
    flex: 1,
    renderCell: (item) => renderTextLineClamp(item.fullName),
  },

  {
    field: 'personalAccountOpeningDate',
    title: t('client.clients.legal.columns.personalAccountOpeningDate'),
    minWidth: 145,
    flex: 1,
    renderCell: (item) => renderCopyHover(item.personalAccountOpeningDate),
  },

  {
    field: 'personalAccountNumber',
    title: t('client.clients.legal.columns.personalAccountNumber'),
    minWidth: 200,
    flex: 1,
    renderCell: (item) => renderTextLineClamp(item.personalAccountNumber),
  },
  {
    field: 'code',
    title: t('client.clients.legal.columns.code'),
    minWidth: 126,
    flex: 1,
    renderCell: (item) => renderTextLineClamp(item.code),
  },
  {
    field: 'centralDepositoryAccountNumber',
    title: t('client.clients.legal.columns.centralDepositoryAccountNumber'),
    minWidth: 120,
    flex: 1,
    renderCell: (item) =>
      renderTextLineClamp(item.centralDepositoryAccountNumber),
  },
  {
    field: 'email',
    title: t('client.clients.legal.columns.email'),
    minWidth: 183,
    flex: 1,
    renderCell: (item) => renderTextLineClamp(item.email),
  },
  {
    field: 'phone',
    title: t('client.clients.legal.columns.phone'),
    minWidth: 185,
    flex: 1,
    renderCell: (item) => renderTextLineClamp(item.phone),
  },
  {
    field: 'countryRegistration',
    title: t('client.clients.legal.columns.countryRegistration'),
    minWidth: 160,
    flex: 1,
    renderCell: (item) => renderTextLineClamp(item.countryRegistration),
  },
  {
    field: 'location',
    title: t('client.clients.legal.columns.location'),
    minWidth: 148,
    flex: 1,
    renderCell: (item) => renderTextLineClamp(item.location),
  },
  {
    field: 'onboardingStatus',
    title: t('client.clients.legal.columns.status'),
    sortable: true,
    minWidth: 346,
    flex: 1,
    renderCell: (item) => renderStatus(item, t),
  },
];

export const useColumns = () => {
  const { t } = useTranslation();
  return getColumns(t);
};
